import React, { createContext, useContext, useState, useCallback } from "react";

const ContactContext = createContext(null);

// Wraps the app so any CTA can open the Contact modal, optionally pre-selecting
// a care plan (e.g. the "Let's talk" button on the Growth card).
export function ContactProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [plan, setPlan] = useState("");

  const openContact = useCallback((planName = "") => {
    setPlan(planName || "");
    setIsOpen(true);
  }, []);

  const closeContact = useCallback(() => setIsOpen(false), []);

  return (
    <ContactContext.Provider value={{ isOpen, plan, openContact, closeContact }}>
      {children}
    </ContactContext.Provider>
  );
}

export function useContact() {
  return useContext(ContactContext);
}
